import moment from "moment";
import { slugs } from "../config/slugs";
import i18next from "i18next";
import { constant } from "../config/constant";
import i18n from "../i18n";

export const normalize = (prop) => {
  return prop
    ?.toLowerCase()
    ?.replace(/\s+/g, "")
    ?.replace(/\//g, "")
    ?.replace(/-/g, "");
};

let generatedNumbers = new Set();
const dapiPaths = ["/booking/", "/managebooking/"];
const clearCookiePaths = ["/content/", "/booking/", "/managebooking/"];

export const randomNumber = () => {
  let randomNumber;
  do {
    randomNumber = Math.random();
  } while (generatedNumbers?.has(randomNumber));

  generatedNumbers?.add(randomNumber);
  return randomNumber;
};

export const setCookies = (keyName, value) => {
  const cookie = [keyName, "=", JSON.stringify(value)]?.join("");
  document.cookie = cookie;
};

export const getCookie = (name) => {
  var result = document.cookie.match(new RegExp(name + "=([^;]+)"));
  result && (result = JSON.parse(result[1]));
  return result;
};
export const isAlphaNumeric = (str) => {
  return (
    str.length === 6 && /^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9]+$/.test(str)
  );
};
export const isLettersOrAlphanumeric = (value) => {
  if (!value) return false;
  const regex = /^[A-Za-z]+[A-Za-z0-9]*$/;
  return value.length === 6 && regex.test(value);
};

export const validateNameField = (value) => {
  var name = value?.trim().replace(/\s+/g, " ");
  return name;
};

export const deleteCookie = (name) => {
  document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};

export const extractFirstWord = (inputString) => {
  const words = inputString?.split(" ");
  return words[0];
};

export const capitalize = (word) => {
  return word?.charAt(0)?.toUpperCase() + word?.slice(1);
};

export const camelCase = (word) => {
  return word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase();
};

export const parseRouteString = (route, unCapitalize) => {
  const words = route?.split("/")?.filter((word) => word !== "");
  let link = "";
  return words?.map((word) => {
    const capitalizedWord =
      word?.charAt(0)?.toUpperCase() +
      word?.slice(1)?.replace(/([A-Z])/g, " $1");
    const unCapitalizedWord =
      word?.charAt(0) +
      word
        ?.slice(1)
        ?.replace(/([A-Z])/g, "$1")
        ?.trim();
    link += `/${word}`;
    return {
      text: unCapitalize ? unCapitalizedWord : capitalizedWord,
      link: link,
    };
  });
};

export const setLocalStorageData = (key, value) => {
  if (typeof window !== "undefined") {
    if (typeof value === "string") {
      window?.localStorage?.setItem(key, value);
    } else {
      window?.localStorage?.setItem(key, JSON.stringify(value));
    }
  }
};

export const getLocalStorageData = (key) => {
  if (typeof window !== "undefined") {
    if (typeof key !== "undefined") {
      const data = window?.localStorage?.getItem(key);
      if (typeof data === "string") {
        return data;
      } else return JSON.parse(data);
    }
  }
};

export const getSessionStorage = (key) => {
  if (typeof window !== "undefined") {
    if (typeof key !== "undefined") {
      const data = window?.sessionStorage?.getItem(key);
      if (typeof data === "string") {
        return data;
      } else return JSON.parse(data);
    }
  }
};

export const setSessionStorage = (key, value) => {
  if (typeof window !== "undefined") {
    if (typeof value === "string") {
      window?.sessionStorage?.setItem(key, value);
    } else {
      window?.sessionStorage?.setItem(key, JSON.stringify(value));
    }
  }
};

export const getDateFormat = (date, type) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1)?.padStart(2, "0");
  const day = String(date.getDate())?.padStart(2, "0");
  const hours = String(date.getHours())?.padStart(2, "0");
  const minutes = String(date.getMinutes())?.padStart(2, "0");
  const seconds = String(date.getSeconds())?.padStart(2, "0");
  if (type) {
    return `${year}${month}${day}${hours}${minutes}${seconds}`;
  } else {
    return `${year}-${month}-${day}`;
  }
};

export const fetchOrSaveLocalizeValue = (
  countryData,
  localeCode,
  isFetch = false,
) => {
  if ((!countryData) instanceof Array) {
    countryData = [];
  }
  const filteredRegionData = countryData?.filter((obj) =>
    obj?.countryDetails?.some(
      (item) =>
        item["countryCode"]?.replace(/\s/g, "")?.toLowerCase() ===
        localeCode?.[1]?.toLowerCase(),
    ),
  )[0];
  const filteredCountryData = filteredRegionData?.countryDetails?.filter(
    (obj) =>
      obj?.countryCode?.replace(/\s/g, "")?.toLowerCase() ===
      localeCode?.[1]?.toLowerCase(),
  )[0];
  const filteredLanguageData = filteredCountryData?.languageDetails?.filter(
    (obj) =>
      obj?.languageCode?.replace(/\s/g, "")?.toLowerCase() === localeCode?.[0],
  )[0];
  let cookieData;
  if (
    (typeof countryData === "undefined" || countryData?.length === 0) &&
    localeCode?.[0]?.toLowerCase() === "en" &&
    localeCode?.[1]?.toLowerCase() === "th"
  ) {
    cookieData = {
      countryCode: "TH",
      countryName: "Thailand",
      languageCode: "EN",
      languageName: "English",
      regionCode: "APAC",
      countryNameEN: "Thailand",
    };
  } else {
    cookieData = {
      ...filteredLanguageData,
      countryCode: filteredCountryData?.countryCode?.replace(/\s/g, ""),
      regionCode: filteredRegionData?.regionCode,
      countryNameEN:
        filteredCountryData?.languageDetails?.[0]?.countryNameEN ||
        filteredCountryData?.languageDetails?.[0]?.countryName,
    };
  }
  setCookies("config", {
    countryCode: cookieData?.countryCode,
    languageCode: cookieData?.languageCode,
    regionCode: cookieData?.regionCode,
    countryNameEN: cookieData?.countryNameEN,
  });

  if (isFetch) {
    return cookieData;
  }
};

export const removeLangFromRoute = (route) => {
  const parts = route?.split("/");
  const lastRoute = parts[parts?.length - 1];
  if (!lastRoute.includes("info") && !lastRoute.includes("agency-booking")) {
    if (parts.length > 2) {
      parts?.splice(1, 1);
    } else {
      return parts[0] + "/";
    }
    return parts?.join("/");
  } else {
    return "/";
  }
};
//This function ensures to remove duplicates based on the data passed and the unique field passed.
export const removeDuplicateJsonObjects = (data, field) => {
  if (data) {
    const updatedData = data?.reduce((acc, curr) => {
      if (!acc.find((item) => item[field] === curr[field])) {
        acc?.push(curr);
      }
      return acc;
    }, []);
    return updatedData;
  }
};

export const updateRecentSearchState = (
  setArray,
  key,
  fieldName,
  updatedData,
  duplicateCheck,
  maxLength,
) => {
  setArray((prevItems) => {
    const item = JSON.parse(getLocalStorageData(key));
    let newItem;
    let isRecentSearchDataExists;
    const dataToUpdate = fieldName ? updatedData[fieldName] : updatedData;
    const isDataExists = item?.find(
      (x) => x?.airportCode === dataToUpdate?.airportCode,
    );

    if (!duplicateCheck) {
      isRecentSearchDataExists = item?.find(
        (x) =>
          x?.flightNum === dataToUpdate?.flightNum &&
          x?.departureDate === dataToUpdate?.departureDate,
      );
    }
    if (
      (duplicateCheck && !isDataExists) ||
      (!duplicateCheck && !isRecentSearchDataExists)
    ) {
      if (prevItems.length >= maxLength) {
        newItem = [...item.slice(1), dataToUpdate];
      } else {
        newItem = [...item, dataToUpdate];
      }
    } else {
      newItem = [...item];
    }

    localStorage.setItem(key, JSON.stringify(newItem));
    return newItem;
  });
};

export const extractSubArray = (array, step, isMobile) => {
  const result = [];
  const length = array?.length;

  if (step === 1) {
    return array;
  } else if (step === 2 && isMobile) {
    for (let i = 0; i < length; i++) {
      const subarray = [];
      subarray?.push(array[i]);
      subarray?.push(array[(i + 1) % length]);
      result?.push(subarray);
    }
  } else if (step > 1 && step <= 4) {
    const subarray = [];
    subarray?.push(array[0]);
    subarray?.push(array[1]);
    array[2] && subarray?.push(array[2]);
    array[3] && subarray?.push(array[3]);
    result?.push(subarray);
  } else {
    for (let i = 0; i < length; i += step - 1) {
      const subarray = [];
      if (step > 2) {
        for (let j = 0; j < step; j++) {
          if (j === step - 1) {
            const obj = array[(i + j) % length];
            subarray?.push({ image: obj?.image, altText: obj?.altText });
          } else {
            subarray?.push(array[(i + j) % length]);
          }
        }
      } else {
        for (let j = 0; j < step; j++) {
          subarray?.push(array[(i + j) % length]);
        }
      }
      result?.push(subarray);
    }
  }

  return result;
};

export const reverseJsonArray = (arr) => {
  const reverseArray = [];
  for (let i = arr?.length - 1; i >= 0; i--) {
    reverseArray?.push(arr[i]);
  }
  return reverseArray;
};

export const validateDepartDate = (date) => {
  const now = moment()?.startOf("day");
  const momentDepartDate = moment(date)?.startOf("day");
  return momentDepartDate?.isBefore(now);
};

export const getApiBaseUrl = (flag) => {
  var rootdomain = window.location.origin;
  if (rootdomain.includes("localhost") || rootdomain.includes("file:/")) {
    return flag == "pss"
      ? process.env.REACT_APP_TG_AMADEUS_URL
      : process.env.REACT_APP_TG_API_BASE_URL;
  } else if (rootdomain.includes("thaiairways.com")) {
    rootdomain = "https://www.thaiairways.com/";
    return flag == "pss"
      ? "https://www.thaiairways.com" + "/pss_router/"
      : rootdomain;
  } else {
    return flag == "pss" ? rootdomain + "/pss_router/" : rootdomain + "/";
  }
};

export const openAndReloadTab = (url, target) => {
  const newTab = window.open(url, target);
  if (newTab) {
    newTab.focus();
  }
};
export const handleAmadeusRedirection = (url, wRef) => {
  url = getApiBaseUrl("pss") + url;
  if (wRef?.current) {
    if (wRef?.current && !wRef?.current?.closed) {
      wRef?.current?.location?.reload();
      wRef?.current?.focus();
    } else {
      wRef.current = window?.open(url);
    }
  } else {
    openAndReloadTab(url, "amadeusTab");
  }
};

export const isUserLoggedIn = () => {
  const accessToken = localStorage.getItem("accesstoken");
  const memberId = sessionStorage.getItem("memberId");

  if (accessToken && memberId) {
    return true;
  } else {
    return false;
  }
};

export const getTierImg = (name) => {
  switch (name) {
    case "silk":
      return "/osci/assets/member_tier.png";
    case "silver":
      return "/osci/assets/silver_tier.png";
    case "gold":
      return "/osci/assets/gold_tier.png";
    case "platinum":
      return "/osci/assets/platinum_tier.png";
    default:
      return null;
  }
};

export const getCardImg = (name) => {
  switch (name) {
    case "silk":
      return "/osci/assets/silverCard.png";
    case "silver":
      return "/osci/assets/goldCard.png";
    case "gold":
      return "/osci/assets/platinumCard.png";
    default:
      return null;
  }
};
export const isValidEmail = (email) => {
  const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  return regex?.test(email);
};

export const isValidWebsite = (website) => {
  const regex =
    /^(?:http(s)?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/;
  return regex?.test(website);
};

export const blockSpecialChar = (str) => {
  const regex = /^[A-Za-z0-9]{0,100}$/;
  const isValid = regex?.test(str);
  if (isValid) {
    return true;
  } else return false;
};

export const crmPasswordPattern = (str) => {
  const regex = /^[A-Za-z\d@#!$%^&+=]{0,25}$/;
  const isValid = regex?.test(str);
  if (isValid) {
    return true;
  } else return false;
};

export const isValidBaggageNum = (str) => {
  const regex = /^[a-zA-Z]{0,2}[0-9]{0,6}$/;
  const isValid = regex?.test(str);
  if (isValid) {
    return true;
  } else return false;
};

export const isValidRopId =
  !sessionStorage?.getItem("isROPEnabled") === "true"
    ? (str) => {
        return (
          /^[a-zA-Z]{0,2}[0-9]{0,5}$/.test(str) &&
          /^[a-zA-Z]/.test(str[0]) &&
          /^[a-zA-Z]/.test(str[1])
        );
      }
    : (enteredText) => /^[0-9\s]*$/.test(enteredText);

export const isValidCorporateId = (str) => {
  return (
    /^[a-zA-Z]{0,3}[0-9]{0,5}$/.test(str) &&
    /^[a-zA-Z]/.test(str[0]) &&
    /^[a-zA-Z]/.test(str[1])
  );
};

export const isValidEventCode = (str) => {
  return (
    /^[a-zA-Z]{0,2}[0-9]{0,7}$/.test(str) &&
    /^[a-zA-Z]/.test(str[0]) &&
    /^[a-zA-Z]/.test(str[1])
  );
};

export const isvalidAlphabet = (str) => {
  return /^[a-zA-Z\s]{0,100}$/.test(str);
};

export const isvalidAlphabetWithThaiSupport = (str) => {
  return /^[a-zA-Z\u0E00-\u0E7F\s]{0,100}$/.test(str);
};

export const isvalidContact = (str) => {
  return /^[0-9-]{0,18}$/.test(str);
};
export const isvalidAddress = (str) => {
  return /^[a-zA-Z0-9,\s|/-]{0,100}$/.test(str);
};
export const isvalidLanguage = (str) => {
  return /^[A-Za-z0-9\s._@-]*$/.test(str);
};

export const isValidPostal = (str) => {
  const regex = /^[A-Za-z0-9 ]{0,10}$/;
  const isValid = regex?.test(str);
  if (isValid) {
    return true;
  } else return false;
};

export const formatDate = (date, type) => {
  if (type) {
    return date?.format("ddd, DD MMM YYYY");
  } else {
    return date?.format("DDMMYY");
  }
};

export const formatNumber = (num) => {
  if (!num) return "";
  return num?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const displayDateFormat = (date) => {
  return date?.format("D MMMM YYYY");
};

export const normalDateFormat = (date) => {
  return date?.format("DD MMM YYYY");
};

export const formatDatalayerData = (data, field) => {
  return data.map((item) => ({
    ...item,
    [field]: moment(item[field]).format("YYYY-MM-DD"),
  }));
};

export const formatContact = (str) => {
  // return str?.replace(/(\d{2})(\d{3})(\d{4})?(\d{5})/, "$1-$2-$3$4");
  return str?.replaceAll("-", "");
};

export const isValidBookingRef = (str) => {
  const string = /^[A-Za-z0-9\s]+$/.test(str);
  const number = /^[1-9\s]*$/.test(str);
  return string || number;
};
export const isNumberOnly = (str) => {
  const number = /^[0-9\s]*$/.test(str);
  return number;
};
export const isNumberDecimalOnly = (str) => {
  const number = /^\d*\.?\d{0,2}$/.test(str);
  return number;
};
export const isNumberDecimalLimitOnly = (str) => {
  const number = /^\d{0,3}(\.\d{0,2})?$/.test(str);
  return number;
};
export const isNumberNoSpacOnly = (str) => {
  const number = /^[0-9]*$/.test(str);
  return number;
};
export const isNumberCommaDotOnly = (str) => {
  const doubleZero = /^00/.test(str);
  const number = /^[0-9,]*$/.test(str);
  return number && !doubleZero;
};

export const isValidSeatNo = (str) => {
  return /^[a-zA-Z]{0,1}[0-9]{0,3}$/.test(str);
};
export const isMiceblockSpecialChar = (str) => {
  const regex = /^[A-Za-z0-9]{0,200}$/;
  const isValid = regex?.test(str);
  if (isValid) {
    return true;
  } else return false;
};

export const isMiceEventName = (str) => {
  const number = /^[a-zA-Z0-9 ]{5,15}$/.test(str);
  return number;
};

export const isResetEmail = (email) => {
  const validRegex = /^[a-zA-Z0-9@._-]*$/.test(email);
  return validRegex;
};

export const isValidTaxId = (str) => {
  return /^[A-Za-z0-9]+$/.test(str);
};

export const checkValidity = (validationKey, enteredText) => {
  switch (validationKey) {
    case "seatNo":
      return isValidSeatNo(enteredText);
    case "rop":
      return isValidRopId(enteredText);
    case "name":
      return isvalidAlphabet(enteredText);
    case "nameWithThai":
      return isvalidAlphabetWithThaiSupport(enteredText);
    case "email":
      return isValidEmail(enteredText);
    case "emailReset":
      return isResetEmail(enteredText);
    case "contact":
      return isvalidContact(enteredText);
    case "noSpecialChar":
      return blockSpecialChar(enteredText);
    case "postal":
      return isValidPostal(enteredText);
    case "bookingRef":
      return isValidBookingRef(enteredText);
    case "address":
      return isvalidAddress(enteredText);
    case "language":
      return isvalidLanguage(enteredText);
    case "number":
      return isNumberOnly(enteredText);
    case "numberNoSpace":
      return isNumberNoSpacOnly(enteredText);
    case "numberComma":
      return isNumberCommaDotOnly(enteredText);
    case "decimal":
      return isNumberDecimalOnly(enteredText);
    case "numberLimit":
      return isNumberDecimalLimitOnly(enteredText);
    case "eventCode":
      return isValidEventCode(enteredText);
    case "miceblockSpecialChar":
      return isMiceblockSpecialChar(enteredText);
    case "miceEventName":
      return isMiceEventName(enteredText);
    case "crmPasswordPattern":
      return crmPasswordPattern(enteredText);
    case "isValidBaggageNum":
      return isValidBaggageNum(enteredText);
    case "corporate":
      return isValidCorporateId(enteredText);
    case "taxId":
      return isValidTaxId(enteredText);
    default:
      return true;
  }
};

export const updateRecentSearchFlightBooking = (
  setArray,
  key,
  fieldName,
  updatedData,
  duplicateCheck,
  maxLength,
) => {
  setArray((prevItems) => {
    const item = JSON.parse(getLocalStorageData(key));
    let newItem;
    let isRecentSearchDataExists;
    const dataToUpdate = fieldName ? updatedData[fieldName] : updatedData;
    const isDataExists = item.find(
      (x) => x?.airportCode === dataToUpdate?.airportCode,
    );
    if (!duplicateCheck) {
      isRecentSearchDataExists = item?.find(
        (x) =>
          x?.from?.airportCode === dataToUpdate?.from?.airportCode &&
          x?.to?.airportCode === dataToUpdate?.to?.airportCode &&
          x?.depart === dataToUpdate?.depart &&
          x?.return === dataToUpdate?.return &&
          x?.class === dataToUpdate?.class &&
          x?.type === dataToUpdate?.type &&
          x?.passengers?.adult === dataToUpdate?.passengers?.adult &&
          x?.passengers?.youth === dataToUpdate?.passengers?.youth &&
          x?.passengers?.child === dataToUpdate?.passengers?.child &&
          x?.passengers?.infant === dataToUpdate?.passengers?.infant,
      );
    }
    if (
      (duplicateCheck && !isDataExists) ||
      (!duplicateCheck && !isRecentSearchDataExists)
    ) {
      if (prevItems.length >= maxLength) {
        newItem = [...item.slice(1), dataToUpdate];
      } else {
        newItem = [...item, dataToUpdate];
      }
    } else {
      newItem = [...item];
    }

    localStorage.setItem(key, JSON.stringify(newItem));
    return newItem;
  });
};

export const updateRecentSearchFlightStatus = (
  setArray,
  key,
  fieldName,
  updatedData,
  maxLength,
) => {
  setArray((prevItems) => {
    const item = JSON.parse(getLocalStorageData(key));
    const length = item?.length ?? 0;
    let newItem;
    let isRecentSearchDataExists;
    // let isFollowedFlightExists;
    let isFirstElement = true;
    let dataToUpdate = fieldName ? updatedData[fieldName] : updatedData;

    dataToUpdate.id = length + 1;
    if (item?.length > 0) {
      isFirstElement = false;
      if (dataToUpdate.type === "Flight Number") {
        isRecentSearchDataExists = item?.find((x) => {
          return (
            x?.departureDate === dataToUpdate?.departureDate &&
            x?.flightNum === dataToUpdate?.flightNum &&
            x?.type === "Flight Number"
          );
        });
      } else {
        isRecentSearchDataExists = item?.find(
          (x) =>
            x?.type === "Route" &&
            moment(x?.departureDate)?.format("DDMMYY") ===
              moment(dataToUpdate?.departureDate)?.format("DDMMYY") &&
            x?.flightNum === dataToUpdate?.flightNum,
        );
      }
    } else {
      isRecentSearchDataExists = false;
      isFirstElement = true;
    }
    if (isFirstElement) {
      newItem = [dataToUpdate];
    } else if (!isRecentSearchDataExists) {
      if (prevItems?.length >= maxLength) {
        newItem = [...item.slice(1), dataToUpdate];
      } else {
        newItem = [...item, dataToUpdate];
      }
    } else {
      newItem = [...item];
    }
    isRecentSearchDataExists = false;
    setLocalStorageData(key, JSON.stringify(newItem));
    return newItem;
  });
};

export const isEmptyChecker = (value) => {
  return (
    value === null ||
    value === undefined ||
    (typeof value === "string" && value?.trim() === "") ||
    (Array.isArray(value) && value?.length === 0) ||
    (typeof value === "object" &&
      !Array.isArray(value) &&
      Object.keys(value)?.length === 0)
  );
};

export const DateFormatter = (date) => {
  const dateParts = date?.split("-");
  return new Date(
    parseInt(dateParts[0]),
    parseInt(dateParts[1]) - 1,
    parseInt(dateParts[2]),
  );
};

export const DateToDayConverter = (date) => {
  return moment(date)?.format("ddd DD, MMM YYYY");
};
export const calculateTimeLeft = (endTime) => {
  const remainingTime = endTime - Date.now();
  return {
    total: remainingTime,
    minutes: Math.floor(remainingTime / 1000 / 60),
    seconds: Math.floor((remainingTime / 1000) % 60),
  };
};

export const formatPriceInternational = (value) => {
  const formattedNumber = new Intl.NumberFormat("en-US")?.format(value);
  return formattedNumber;
};

export const handleClearDetails = () => {
  sessionStorage.clear();
  localStorage.removeItem("isROPLoggedIn");
  localStorage.removeItem("isCRMLoggedIn");
  localStorage.removeItem("accesstoken");
  window.localStorage.removeItem("expireTime");
};

export const processJsonWithHtmlContent = (json, fieldNames) => {
  return json.map((item) => {
    const tempContainer = document.createElement("div");
    tempContainer.innerHTML = item?.label;
    const fields = tempContainer?.children;
    const rowData = {};
    Array.from(fields)?.forEach((field, index) => {
      const key = fieldNames[index]?.label;
      const value = field?.textContent?.trim();
      if (key) {
        rowData[key] = value;
      }
    });
    return rowData;
  });
};

export const processJsonWithHtmlContentVariant = (json, fieldNames) => {
  return json.map((item) => {
    const tempContainer = document.createElement("div");
    tempContainer.innerHTML = item?.label;
    const fields = tempContainer?.children;
    const rowData = {};
    Array.from(fields)?.forEach((field, index) => {
      if (index <= fieldNames.length - 1) {
        const key = fieldNames[index]?.label;
        const value = field?.textContent?.trim();
        if (key) {
          rowData[key] = value;
        }
      }
    });
    return rowData;
  });
};

export const mergeTwoAirportObjects = (json1, json2, field, filterName) => {
  const mergedArray = json1?.map((item1) => {
    const matchedItem = json2?.find((item2) => item2[field] === item1[field]);
    return { ...item1, ...(matchedItem || {}) };
  });
  return mergedArray;
  // const updatedData = mergedArray?.filter(
  //   (data) => data?.[filterName] === true,
  // );
  // return updatedData;
};

export const getKeyByValue = (object, value) => {
  for (let prop in object) {
    if (object.hasOwnProperty(prop)) {
      if (object[prop] === value) {
        return prop;
      }
    }
  }
};

export const getFlightType = (value) => {
  switch (value) {
    case "Multi-City":
      return "M";
    case "One-way":
      return "O";
    case "Return":
      return "R";
    default:
      break;
  }
};

export const displayRoutes = (arr) => {
  let routeStrings = arr?.map(
    ({ from, to }) => `${from?.airportCode} - ${to?.airportCode}`,
  );
  let finalRoute = routeStrings[0] || ""; // Start with the first route

  for (let i = 1; i < routeStrings?.length; i++) {
    let prevRoute = finalRoute?.split(" - ");
    let currRoute = routeStrings[i]?.split(" - ");

    // If previous destination matches current origin, merge
    if (prevRoute[prevRoute.length - 1] === currRoute[0]) {
      finalRoute += " - " + currRoute[1]; // Append only the destination
    } else {
      finalRoute += " // " + routeStrings[i]; // Separate the routes
    }
  }
  // Format and print output
  return finalRoute;
};

export const formattedLanguageCountryCode = (i18n) => {
  return process.env.REACT_APP_LEGACY_COEXIST
    ? i18n?.language?.split("-")[0] +
        "_" +
        i18n?.language?.split("-")[1]?.toUpperCase()
    : i18n?.language;
};

export const pickFieldsFromObjects = (obj, fields) =>
  fields?.reduce((newObj, field) => {
    if (obj[field] !== undefined) newObj[field] = obj[field];
    return newObj;
  }, {});

export const updateArray = (arr, newObj, index) => {
  if (arr.length > index) {
    arr[index] = newObj;
  } else {
    arr?.push(newObj);
  }
  return arr;
};

export const parseCustomDateTime = (timeStr, dateStr, timeZone) => {
  const offset = timeZone?.replace("UTC", "")?.replace("GMT", "")?.trim();
  const formattedOffset = offset?.replace(
    /^(\+|-)?(\d)$/,
    "$1" + "0$2" + ":00",
  );
  return moment(`${dateStr}${timeStr}`, "DDMMYYHHmm")?.utcOffset(
    formattedOffset,
  );
};

export const dataLayerGetter = (eventkey) => {
  return window?.dataLayer?.filter((item) => item?.event === eventkey);
};

export const formatNames = (nameString) => {
  const names = nameString?.split(" ");

  const formattedNames = names?.map((name) => {
    return name?.charAt(0)?.toUpperCase() + name?.slice(1)?.toLowerCase();
  });

  return formattedNames?.join(" ");
};

export const genderNameValidation = (fullname) => {
  let lowerCaseFullname = fullname?.toLowerCase();
  if (lowerCaseFullname?.includes("prefer not to say")) {
    lowerCaseFullname = lowerCaseFullname?.replace(/prefer not to say/i, "");
  }
  if (lowerCaseFullname?.includes("null")) {
    lowerCaseFullname = lowerCaseFullname?.replace(/null/i, "");
  }
  if (lowerCaseFullname?.includes("undefined")) {
    lowerCaseFullname = lowerCaseFullname?.replace(/undefined/i, "");
  }
  return formatNames(lowerCaseFullname);
};

export const formatPhoneNumberDisplay = (phoneNumber) => {
  const parts = phoneNumber?.split("-");
  if (parts?.length > 2 && /^0+$/.test(parts[1])) {
    return `${parts[0]}-${parts[2]}`;
  } else {
    return phoneNumber;
  }
};

export const fetchAmadeusSupportedLanguage = (lngCode, i18n) => {
  const countryCode = i18n?.language?.split("-")[1]?.toLowerCase();
  switch (lngCode) {
    case "en":
    case "vi":
    case "tr":
    case "no":
      return "gb";
    case "zh":
      if (countryCode === "tw" || countryCode === "hk") {
        return "tw";
      } else {
        return "cn";
      }
    case "sv":
      return "se";
    case "ja":
      return "jp";
    default:
      return lngCode;
  }
};

export const getFullName = (salutation, firstName, middleName, lastName) => {
  if (!isEmptyChecker(middleName)) {
    const fullName = `${salutation} ${firstName} ${middleName} ${lastName}`;
    return genderNameValidation(fullName);
  } else {
    const fullName = `${salutation} ${firstName} ${lastName}`;
    return genderNameValidation(fullName);
  }
};

export const slashFormatter = (value) => {
  return value?.replace(/-/g, "/");
};

export const getLanguageCountry = (url) => {
  const updatedUrl = url?.toLowerCase();
  const regex = /(?:\/|^)([a-z]{2}-[a-z]{2})(?:\/|$)/;
  const decodedUrl = decodeURIComponent(updatedUrl); // Matches 'en-US', 'fr-FR', etc.
  const match = decodedUrl?.match(regex);
  return match ? match[1] : null;
};

export const blackoutDateExtracter = (ranges) => {
  try {
    if (typeof ranges !== "string") {
      if (Array.isArray(ranges)) {
        ranges = JSON.stringify(ranges);
      } else {
        throw new Error("Invalid input: Expected a JSON string or an array.");
      }
    }
    ranges = ranges?.replace(/'/g, '"');

    ranges = JSON.parse(ranges);

    if (!Array.isArray(ranges)) {
      throw new Error("Invalid data format. Expected an array.");
    }
    const result = ranges?.flatMap(([start, end]) => {
      let currentDate = new Date(start?.split("-")?.reverse()?.join("-"));
      let endDate = new Date(end?.split("-")?.reverse()?.join("-"));
      let dates = [];

      while (currentDate <= endDate) {
        dates?.push(currentDate?.toISOString()?.split("T")[0]); // Convert to YYYY-MM-DD
        currentDate?.setDate(currentDate?.getDate() + 1);
      }
      return dates;
    });

    return result;
  } catch (error) {
    return [];
  }
};

export const getAEMImageRootPath = () => {
  let baseURL = window?.location?.origin + "/";
  if (window?.location?.origin?.includes("localhost")) {
    baseURL = "https://tgosci-sit.com/";
  }
  return baseURL;
};

export const formatAmount = (num) => {
  if (num >= 1_000_000_000) {
    return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";
  } else if (num >= 1_000_000) {
    return (num / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  } else if (num >= 1_000) {
    return (num / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
  } else {
    return num.toString();
  }
};

export const isPastDate = (customDate) => {
  if (customDate) {
    let tdDate = new Date();
    tdDate.setHours(0, 0, 0, 0);
    let custDate = new Date(customDate);
    custDate.setHours(0, 0, 0, 0);
    if (custDate.getTime() < tdDate.getTime()) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export const getAirportDetails = (array, code) => {
  const filteredObj = array?.filter((x) => x?.airportCode === code)?.[0];
  return filteredObj;
};

export const tripDurationConversion = (arrivalTime, departureTime) => {
  const arrivalMoment = moment(arrivalTime, "HHmm");
  let departureMoment = moment(departureTime, "HHmm");
  if (departureMoment.isBefore(arrivalMoment)) {
    departureMoment.add(1, "day");
  }
  const duration = moment.duration(departureMoment.diff(arrivalMoment));
  const hours = Math.floor(duration.asHours());
  const minutes = duration.minutes();

  const splitDuration = hours + " " + "h" + " " + minutes + " " + "min";
  return splitDuration;
};

export const getValidText = (text) => {
  if (!text || typeof text !== "string") return "";

  const decoded = decodeURIComponent(text.trim());

  const words = decoded.split(/\s+/); // Split by space(s)
  if (words[0] === "Boeing" && words?.length > 1) {
    return "B" + words[1]; // Boeing case
  } else if (words[0] === "B777-200" && words?.length === 1) {
    return words[0] + "ER"; // B777-200 case
  } else if (words?.length === 1 && words[0]) {
    return words[0]; // Only one word: return it
  } else if (words?.length === 2) {
    return words[1] || words[0]; // Fallback in case one is empty
  }

  return "";
};

export const envFinder = () => {
  const env = process.env.REACT_APP_TG_API_BASE_URL;
  switch (env?.split("/")[2]) {
    case "tgosci-sit":
      return "SIT";
    case "tgosci-uat":
      return "UAT";
    case "tgosci-preprod":
      return "PREPROD";
    case "osci.thaiairways.com":
      return "PROD";
    default:
      return "SIT";
  }
};

export const removei18Code = (path) => {
  if (!path?.includes(i18next.language)) {
    return path[0] === "/" ? path?.slice(1) : path;
  } else {
    return path?.split("/")?.slice(2)?.join("/");
  }
};

export const getTranslatedPath = (pathSegments) => {
  const removedi18Path = removei18Code(pathSegments);
  const lan = i18next.language?.split("-")?.[0];
  // const removei18Code = pathSegments?.includes(i18next.language) ? pathSegments?.split("/")?.slice(2)?.join("/") : `${i18n.language}/${pathSegments?.join("/")}`
  const languageCode = constant?.routeTranslationLan?.includes(lan)
    ? lan
    : "en";
  const translated = slugs[removedi18Path]?.[languageCode] || removedi18Path;
  const languageAddedPath = translated?.includes(i18n.language)
    ? translated
    : `${i18n.language}/${translated}`;
  return `/${languageAddedPath}`;
};

export const formatDuration = (durationStr) => {
  if (!durationStr || !durationStr?.includes(":")) return "0 h 0min";
  const [hoursStr, minutesStr] = durationStr?.split(":");
  const hours = parseInt(hoursStr, 10);
  const minutes = parseInt(minutesStr, 10);
  const duration = moment.duration({ hours, minutes });
  return `${Math.floor(duration?.asHours())} h ${duration?.minutes()} min`;
};

export const getOriginalPath = (path) => {
  const langRemovedPath = path?.split("/")?.slice(2)?.join("/");
  const slashRemovedPath =
    langRemovedPath[langRemovedPath?.length - 1] === "/"
      ? langRemovedPath?.slice(0, -1)
      : langRemovedPath;
  for (const routes in slugs) {
    const route = slugs[routes];
    for (const path in route) {
      if (route[path] === slashRemovedPath) {
        return routes;
      }
    }
  }

  return slashRemovedPath;
};

export const removeLastSlash = (path) => {
  return path[path?.length - 1] === "/" ? path?.slice(0, -1) : path;
};

export const getCheckinMarket = (object, value) => {
  for (let prop in object) {
    if (object.hasOwnProperty(prop)) {
      return object[value] ?? false;
    }
  }
};

export const getDapiBookingDeparture = (object, fromcode, tocode) => {
  if (!object) return false;
  let cashMilesFlow = false;
  if (window.location.pathname?.includes("cash-plus-miles")) {
    cashMilesFlow = true;
  }
  const departureMap =
    object?.departures?.length && Array.isArray(object?.departures)
      ? object?.departures
      : [];

  const routemap =
    cashMilesFlow &&
    object?.cashPlusMilesRoutes?.length &&
    Array.isArray(object?.routes)
      ? object?.cashPlusMilesRoutes
      : object?.routes?.length && Array.isArray(object?.routes)
        ? object?.routes
        : [];

  if (
    fromcode &&
    tocode &&
    routemap?.length &&
    routemap.indexOf(fromcode + "-" + tocode) > -1
  ) {
    return true;
  }

  if (cashMilesFlow && routemap?.length && routemap.indexOf(fromcode) > -1)
    return true;

  if (fromcode && departureMap?.length && departureMap.indexOf(fromcode) > -1) {
    return true;
  }

  if (object?.allDepartureDapi) {
    return true;
  }

  return false;
};

export const getDapiBookingMarket = (object, value) => {
  if (!object) return false;

  // if allMarketDapi is false and enabled for specific market
  if (object?.allMarketDapi === false) {
    return object?.markets?.[value] ?? false;
  }

  if (object?.allMarketDapi === true) {
    // if allMarketDapi is true and disabled for specific market
    if (
      object?.markets?.hasOwnProperty(value) &&
      object?.markets[value] === false
    ) {
      return false;
    }

    return true;
  }

  return false;
};
export const getDapiMultiBookingMarket = (object, value) => {
  if (!object) return false;

  if (object?.DAPIMultienable === true) {
    // if allMarketDapi is false and enabled for specific market
    if (object?.allMarketDapi === false) {
      //  return object?.multicitySiteEdition?.[value] ?? false;
      if (object?.multicitySiteEdition?.[value]) {
        return true;
      } else if (
        Object.keys(object?.multicitySiteEdition)?.length === 0 ||
        Array.isArray(object?.multicitySiteEdition)?.length === 0
      ) {
        return true;
      } else {
        return false;
      }
    }

    if (object?.allMarketDapi === true) {
      // if allMarketDapi is true and disabled for specific market
      if (
        object?.multicitySiteEdition?.hasOwnProperty(value) &&
        object?.multicitySiteEdition[value] === false
      ) {
        return false;
      }

      return true;
    }
  }

  return false;
};

export async function getDeviceName() {
  try {
    if (navigator?.userAgentData?.getHighEntropyValues) {
      const data = await navigator?.userAgentData?.getHighEntropyValues([
        "platform",
        "platformVersion",
        "fullVersionList",
        "model",
      ]);

      if (data?.model?.length > 0) {
        return cleanModelName(data.model);
      }
    }
  } catch (e) {}
  const ua = navigator?.userAgent;

  if (/iPhone/i.test(ua)) return "iPhone";
  if (/iPad/i.test(ua)) return "iPad";

  const match = ua?.match(/Android.*;\s*(.*?)\s*(Build|\))/i);
  if (match && match[1]) {
    return modelName(match[1]);
  }

  const browser = detectBrowser(ua);
  const os = detectOS(ua);

  return `${browser} on ${os}`;
}

function modelName(name) {
  if (!name) return "";
  let cleaned = name?.replace(/_/g, " ")?.trim();
  return cleaned?.charAt(0)?.toUpperCase() + cleaned?.slice(1);
}

function detectBrowser(ua) {
  if (/Edg/i.test(ua)) return `Edge ${ua?.match(/Edg\/([\d.]+)/)?.[1] || ""}`;
  if (/Chrome/i.test(ua))
    return `Chrome ${ua?.match(/Chrome\/([\d.]+)/)?.[1] || ""}`;
  if (/Firefox/i.test(ua))
    return `Firefox ${ua?.match(/Firefox\/([\d.]+)/)?.[1] || ""}`;
  if (/Safari/i.test(ua) && !/Chrome/i.test(ua))
    return `Safari ${ua?.match(/Version\/([\d.]+)/)?.[1] || ""}`;
  return "NA";
}

function detectOS(ua) {
  if (/Windows NT/i.test(ua)) return "Windows";
  if (/Mac OS X/i.test(ua)) return "macOS";
  if (/Linux/i.test(ua)) return "Linux";
  return "NA";
}

export const isDapiPath = () => {
  return dapiPaths?.some((item) => location.pathname?.includes(item));
};
export const isClearCookiePath = () => {
  return clearCookiePaths?.some((item) => location.pathname?.includes(item));
};

export const getLangFromUrl = () => {
  return location.search
    ? new URLSearchParams(location.search)?.get("lang")
    : "";
};

export const maskString = (data, start) => {
  if (data?.length <= start) return data;
  return data?.slice(0, start) + "x".repeat(data?.length - start);
};

export const removeChar = (str = "", char = "") => {
  const index = str?.indexOf(char);
  if (index === -1) return str;
  return str.slice(0, index);
};
export const getTotalCookieSize = () => {
  const allCookiesString = document.cookie;

  const encoder = new TextEncoder();
  const bytes = encoder.encode(allCookiesString);
  const totalSize = bytes.length;
  return totalSize;
};

export const getErrorCodeTitleAndDesc = (url, method, code, jsonData) => {
  if (!url || !method || !code) return null;

  const updatedUrl = url.replace(/^\/|\/$/g, "").replace(/\//g, "_");
  const updatedMethod = method?.trim()?.toUpperCase();

  const key = `error.${updatedUrl}.${updatedMethod}.${code}`;

  const title = jsonData?.translation?.[`${key}.title`] || null;
  const desc = jsonData?.translation?.[`${key}.desc`] || null;

  return { title, desc };
};
export const isAbsoluteHttp = (url) =>
  typeof url === "string" && /^https?:\/\//i.test(url);

export const isProtocolRelative = (url) =>
  typeof url === "string" && /^\/\//.test(url);

export const resolveImageUrl = (img) => {
  const input = (img || "").trim();
  if (!input) return "";

  if (isAbsoluteHttp(input) || isProtocolRelative(input)) {
    return isProtocolRelative(input) ? `https:${input}` : input;
  }
  const root = (getAEMImageRootPath() || "").replace(/\/+$/, "");
  const path = input.startsWith("/") ? input : `/${input}`;
  return `${root}${path}`;
};

export const changeLangMonth = (data) => {
  let customizeData = data?.split(" ");
  let Dates = customizeData?.[0];
  let Month = customizeData?.[1];
  let Year = customizeData?.[2];
  const langObj = {
    Jan: i18n?.t("label_jan"),
    Feb: i18n?.t("label_feb"),
    Mar: i18n?.t("label_mar"),
    Apr: i18n?.t("label_apr"),
    May: i18n?.t("label_may"),
    Jun: i18n?.t("label_jun"),
    Jul: i18n?.t("label_jul"),
    Aug: i18n?.t("label_aug"),
    Sep: i18n?.t("label_sep"),
    Oct: i18n?.t("label_oct"),
    Nov: i18n?.t("label_nov"),
    Dec: i18n?.t("label_dec"),
  };
  return `${Dates} ${langObj?.[Month]} ${Year}`;
};

export const getAuthorizationHeader = (token) => {
  const isRopEnabled =
    sessionStorage?.getItem("isROPEnabled") === "true" ? true : false;
  return {
    [isRopEnabled ? "App-Authorization" : "Authorization"]: token,
  };
};

export const getIsRopEnabled = () => {
  return sessionStorage?.getItem("isROPEnabled") === "true" ? true : false;
};

export const getBaseLang = (lng) => {
  const parts = lng?.split("-");
  return parts?.reverse()?.join("/") || lng;
};

export const displayDescription = (code, description) => {
  return i18n.t(code, {
    defaultValue: description,
  });
};

export const maskNumber = (str) => {
  return (
    str?.replace(/[_-]/g, "")?.slice(0, -4)?.replace(/[*]/g, "X") +
    str?.replace(/[_-]/g, "")?.slice(-4)
  );
};

